import React, { Component } from 'react';
import styled from 'styled-components';

import Text from '~/components/Text';
import Headline from '~/components/Headline';
import Closer from './Closer';

import { getEmbedCode } from '~/components/Sharing/ShareUtils';

const EmbedCode = styled.div`
  background: #eee;
  border: 0;
  white-space: pre-wrap;
  font-family: monospace;
  padding: 1em;
  word-break: break-all;
  font-size: 12px;
  margin-top: 10px;
`;

class Embed extends Component {
  render() {
    return (
      <>
        <Closer setInfoboxContent={this.props.setInfoboxContent} />
        <Headline>Einbetten</Headline>
        <Text>
          Mit diesem Code können Sie die Grafik kostenlos in Ihre Website
          einbetten.
        </Text>
        <EmbedCode>
          <code>{getEmbedCode().trim()}</code>
        </EmbedCode>
      </>
    );
  }
}

export default Embed;
